import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getAccessToken();

  // Skip adding token for public endpoints (auth and catalog)
  if (req.url.includes('/api/auth/login') ||
      req.url.includes('/api/auth/signup') ||
      req.url.includes('/api/auth/refresh') ||
      req.url.includes('/api/catalog/')) {
    return next(req);
  }

  // Add token to request if available
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req);
};
